import React from 'react';
import { Activity, Plus, Search, Filter } from 'lucide-react';
import Layout from '../components/Layout';

const Trainings = () => {
  return (
    <Layout title="Entrenamientos" description="Gestiona los entrenamientos de tu club">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Entrenamientos Disponibles</h2>
        </div>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center">
          <Plus size={20} className="mr-2" />
          Nuevo Entrenamiento
        </button>
      </div>

      {/* Filtros y búsqueda */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <div className="flex gap-4">
          <div className="flex-1 relative">
            <Search size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar entrenamientos..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <button className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center">
            <Filter size={20} className="mr-2" />
            Filtros
          </button>
        </div>
      </div>

      {/* Contenido placeholder */}
      <div className="bg-white rounded-lg shadow-sm p-8 text-center">
        <Activity size={64} className="mx-auto text-gray-400 mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Gestión de Entrenamientos</h3>
        <p className="text-gray-600 mb-6">
          Aquí podrás crear, editar y gestionar todos los entrenamientos de tu club de running.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-left">
          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Entrenamientos Base</h4>
            <p className="text-sm text-gray-600">Sesiones de resistencia aeróbica</p>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Intervalos</h4>
            <p className="text-sm text-gray-600">Entrenamientos de alta intensidad</p>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Recuperación</h4>
            <p className="text-sm text-gray-600">Sesiones de recuperación activa</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Trainings;
